import React, { useState, useCallback } from 'react';
import DynamicModal from './DynamicModal';
import { generateRandomBase64 } from '../utility';

function DownloadModal({
  link,
  buttonText,
  buttonClassName = 'btn btn-success btn-sm w-100',
  size = 'lg',
  directLink = false,
  onOpen,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = useCallback(() => setIsOpen(false), []);

  const handleOpen = () => {
    setIsOpen(true);
    if (onOpen) onOpen();
  };

  if (directLink) {
    return (
      <a
        className={buttonClassName}
        href={link}
        target="_blank"
        rel="noreferrer"
      >
        {buttonText}
      </a>
    );
  }

  return (
    <>
      <button className={buttonClassName} onClick={handleOpen}>
        {buttonText}
      </button>
      <DynamicModal
        isOpen={isOpen}
        toggle={toggle}
        dataId={`download-modal-${buttonText}`}
        size={size}
      >
        <iframe
          src={`${link}?reset=${generateRandomBase64(16)}`}
          style={{ border: 'none', width: '100%', height: '40vh' }}
          frameBorder="0"
          allowFullScreen
        ></iframe>
      </DynamicModal>
    </>
  );
}

export default DownloadModal;
